var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.crag)?_c('link-list',{attrs:{"linkable-id":_vm.crag.id,"linkable-type":"Crag"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }